import { X } from "lucide-react";

export default function WizardModal({ title, onClose, children, testId, wide = false }) {
  return (
    <div data-testid={testId} className="fixed inset-0 lg:left-72 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/25 backdrop-blur-[2px]"
        onClick={onClose}
        data-testid={`${testId}-overlay`}
      />
      <div className={`relative bg-[#F9F8F6] border border-neutral-300 shadow-2xl w-full ${wide ? "max-w-3xl" : "max-w-2xl"} max-h-[90vh] overflow-y-auto`}>
        <div className="sticky top-0 bg-[#F9F8F6] border-b border-neutral-200 px-6 py-4 flex items-center justify-between z-10">
          <p className="ed-eyebrow">{title}</p>
          <button
            data-testid={`${testId}-close`}
            onClick={onClose}
            className="p-1.5 border border-neutral-300 hover:border-neutral-900 hover:bg-neutral-900 hover:text-white transition-colors"
          >
            <X size={14} strokeWidth={1.5} />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
